export default [
  'ResourceService',
  class CobrandedAPISerice {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/cobranded';
    }

    getRegistrationData(partnerId) {
      if (!partnerId) {
        return this._resourceService.errorPromise('missing params');
      }

      return this._resourceService.get(`${this._API_BASE}/${partnerId}/registration`);
    }

    uploadFile(partnerId, formData) {
      if (!partnerId || !formData) {
        return this._resourceService.errorPromise('missing params');
      }

      return this._resourceService.postFile(`${this._API_BASE}/${partnerId}/orders/bulk-process`, formData);
    }

    getImportHistory(partnerId) {
      if (!partnerId) {
        return this._resourceService.errorPromise('missing params');
      }

      return this._resourceService.get(`${this._API_BASE}/${partnerId}/orders/bulk-process/history?${moment().format()}`);
    }

    getImportStatus(partnerId, processId) {
      if (!partnerId || !processId) {
        return this._resourceService.errorPromise('missing params');
      }

      return this._resourceService.get(`${this._API_BASE}/${partnerId}/orders/bulk-process/history/${processId}?${moment().format()}`);
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/api-services/cobranded-service.js